import { render, staticRenderFns } from "./DeliverymenOnline.vue?vue&type=template&id=3a15aeb2"
import script from "./DeliverymenOnline.vue?vue&type=script&lang=js"
export * from "./DeliverymenOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports